<template>
  <div>
    <pop-modal
      :visible="visible"
      :title="isModule ? '选择商品' : '商品类别'"
      width="100%"
      :height="100"
      @cancel="handelCancel"
    >
      <a-tabs default-active-key="1" v-if="isModule">
        <a-tab-pane key="1" tab="商品编码"> </a-tab-pane>
        <a-tab-pane key="2" tab="税收编码" force-render></a-tab-pane>
      </a-tabs>
      <div class="main-content">
        <div class="left-cont">
          <div class="left-edit">
            <div><img src="@/assets/add.png" />增加</div>
            <div><img src="@/assets/edit.png" />修改</div>
            <div><img src="@/assets/delete.png" />删除</div>
          </div>
          <div class="category">
            <a-tree show-line :default-expanded-keys="['0-0-0']">
              <a-icon slot="switcherIcon" type="down" />
              <a-tree-node key="0-0" title="商品类别">
                <a-tree-node key="0-0-0" title="自动保存" />
              </a-tree-node>
            </a-tree>
          </div>
        </div>
        <div class="right-cont">
          <div class="export-import">
            <input type="radio" name="" id="" /> 未赋码 <input type="radio" name="" id="" /> 已赋码
            <a-button type="primary" ghost v-if="!isModule"> 批量赋码 </a-button>
            <a-button type="primary" ghost v-if="!isModule"> 批量修改 </a-button>
            <a-button type="primary" ghost v-if="!isModule"> 导入 </a-button>
            <a-button type="primary" ghost v-if="!isModule"> 导出 </a-button>
          </div>
          <div class="option-btn">
            <div class="edit-group">
              <a-button type="primary" ghost @click="editGoods('add')"> 增加 </a-button>
              <a-button type="primary" ghost @click="editGoods('edit')"> 修改 </a-button>
              <a-button type="primary" ghost @click="deletGoods()"> 删除 </a-button>
            </div>
            <div class="search">
              <a-input
                v-model="goodsCode"
                placeholder="请输入客户编码、名称、税号等信息"
                @pressEnter="search()"
                @change="search()"
              >
                <a-icon slot="prefix" type="search" />
              </a-input>
              <a-button type="primary" @click="search()"> 搜索 </a-button>
              <a-button type="primary" @click="onSelect()"> 选择 </a-button>
            </div>
          </div>

          <div class="option-btn"></div>
          <m-table
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
              onDbClick: isModule && onDbClick,
            }"
            :columns="columns"
            :data-source="listOfData"
            :pages="pages"
            @pro="pro()"
            @next="next()"
            @changeShowCount="changeShowCount"
          ></m-table>
        </div>
      </div>
    </pop-modal>
    <!-- 编辑商品编码 -->
    <pop-modal width="750px" :height="70" :isDrag="true" :title="'商品编码' + modalType" :visible="isEdit" @cancel="cancelForm()">
      <div style="padding: 12px 24px">
        <a-form labelAlign="left">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="商品名称" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input v-model="goods.name"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="所属分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="税收分类编码" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input v-model="goods.goodsCode" @click="$refs.TaxNoForm.show('module')">
                  <a-icon slot="addonAfter" type="container" />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="简码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="goods.shortName"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="税收分类名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="goods.goodsName" disabled></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="税率" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-select v-model="goods.taxRate">
                  <a-select-option :value="item.value" v-for="item in rateList" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="享受优惠政策" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="goods.isEnjoyPolic">
                  <a-select-option value="N"> 否 </a-select-option>
                  <a-select-option value="Y"> 是 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <div style="display: inline-block">
                <span><span style="color: red">*</span>含税标志:</span>
                <select v-model="goods.haveTax" style="margin-left: 5px; border: 1px solid; background-color: #fff">
                  <option value="N">否</option>
                  <option value="Y">是</option>
                </select>
              </div>
              <div style="display: inline-block; margin-left: 20px">
                <span>隐藏标志:</span>
                <select :value="'N'" style="margin-left: 5px; border: 1px solid; background-color: #fff">
                  <option value="N">否</option>
                  <option value="Y">是</option>
                </select>
              </div>

              <!-- <a-form-item label="含税标志" required>
                <a-select v-model="goods.haveTax">
                  <a-select-option value="N"> 否 </a-select-option>
                  <a-select-option value="Y"> 是 </a-select-option>
                </a-select>
              </a-form-item> -->
            </a-col>
            <!-- <a-col :span="6">
              <a-form-item label="隐藏标志">
                <select v-model="goods.isHiddle">
                  <option value="N">否</option>
                  <option value="Y">是</option>
                </select>
              </a-form-item>
            </a-col> -->
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="优惠政策类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input disabled v-model="goods.policyType"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="goods.unitPrice"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="goods.guiGe"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="计量单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="goods.units"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <div style="visible: none; height: 53px"></div>
          <div
            :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'center',
              zIndex: 1,
            }"
          >
            <a-button style="margin: 0 20px" type="primary" @click="submitFrom()" :loading="submitLoad">保存</a-button>
            <a-button style="margin: 0 20px" type="primary" @click="cancelForm()">取消</a-button>
          </div>
        </a-form>
      </div>
    </pop-modal>
    <tax-no ref="TaxNoForm" @emitRowKey="emitRowKey"></tax-no>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam, searchData } from '@/utils/util.js'
import taxNo from './taxNo.vue'
import { mapGetters } from 'vuex'
const deafultGoods = {
  id: '',
  code: '',
  name: '',
  goodsCode: '',
  goodsName: '',
  shortName: '',
  taxItem: '',
  taxRate: '',
  guiGe: '',
  units: '',
  unitPrice: '',
  haveTax: '',
  isHiddle: '',
  isEnjoyPolic: '',
  policyType: '',
  enterpriseId: '',
  goodsCodeId: '',
  stuId: '',
  domain: '',
}
const defaultPages = {
  total: 0,
  pageIndex: 1,
  totalPage: 0,
  showCount: 10,
  currentPage: 1,
  index: -1,
}
export default {
  components: {
    taxNo,
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
      isEdit: false,
      value: '',
      selectedRowKeys: [],
      columns: [
        {
          title: '编码',
          dataIndex: 'code',
          width: 70,
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 130,
        },
        {
          title: '简码',
          dataIndex: 'shortName',
          width: 70,
        },
        {
          title: '税率',
          dataIndex: 'taxRate',
          width: 50,
          customRender: (v) => v * 100 + '%',
        },
        {
          title: '规格型号',
          dataIndex: 'guiGe',
          width: 130,
        },

        {
          title: '计量单位',
          dataIndex: 'units',
          width: 85,
        },
        {
          title: '单价',
          dataIndex: 'unitPrice',
          width: 100,
        },
        {
          title: '含税价标志',
          dataIndex: 'haveTax',
          width: 100,
          customRender: (v) => (v === 'Y' ? '是' : '否'),
        },
        {
          title: '税收分类编码',
          dataIndex: 'goodsCode',
          width: 120,
        },
        {
          title: '享受优惠政策',
          dataIndex: 'isEnjoyPolic',
          width: 90,
          customRender: (v) => (v === 'Y' ? '是' : '否'),
        },
        {
          title: '税收分类名称',
          dataIndex: 'goodsName',
          width: 120,
        },
        {
          title: '优惠政策类型',
          dataIndex: 'policyType',
          width: 90,
        },
        {
          title: '隐藏标志',
          dataIndex: 'isHiddle',
          width: 80,
          customRender: (v) => '否',
        },
        // {
        //   title: '商品税目',
        //   dataIndex: 'taxItem',
        //   width: 150,
        // },
      ],
      pages: {
        total: 0,
        pageIndex: 1,
        totalPage: 0,
        showCount: 10,
        currentPage: 1,
        index: -1,
      },
      listOfData: [],
      maxCode: -1,
      goodsCode: '',
      rateList: [
        { value: '0.13', label: '13%' },
        { value: '0.09', label: '9%' },
        { value: '0.06', label: '6%' },
        { value: '0.05', label: '5%' },
        { value: '0.03', label: '3%' },
        { value: '0.015', label: '按减1.5%计算' },
        { value: '0.0', label: '0%' },
        { value: '0.0', label: '中外合作油气田' },
        { value: '0.04', label: '4%' },
      ],
      // 客户编码新增编辑
      goods: deafultGoods,
      isModule: false,
      submitLoad: false,
      modalType: '添加',
    }
  },
  computed: {
    ...mapGetters('practice', ['LOGIN_INFO']),
  },
  methods: {
    show(module) {
      this.isModule = !!module
      this.visible = true
      this.getGoodsList()
    },
    async getGoodsList() {
      let params = parseParam({
        showCount: this.pages.showCount,
        currentPage: this.pages.currentPage,
      })
      if (this.goodsCode) {
        params = parseParam(searchData(this.goodsCode))
      }
      const res = await this.$http.get(`${Urls.getGoodsList}&${params}`)
      if (res.statusCode === '200') {
        this.listOfData = res.data
        this.pages.total = res.total
        this.pages.totalPage = res.totalPage
        this.maxCode = res.total
      }
    },
    handelCancel() {
      this.visible = false
    },
    initGoodsNo() {
      this.goodsCode = ''
      this.page = JSON.parse(JSON.stringify(defaultPages))
    },
    emitRowKey(val) {
      this.$refs.TaxNoForm.handelCancel()
      const data = val[0]
      const rate = data.rate.replace('%', '')
      this.goods.taxRate = parseFloat(rate) / 100 === undefined || isNaN(parseFloat(rate)) ? 0 : parseFloat(rate) / 100
      this.goods.taxRate = this.goods.taxRate.toString()
      this.goods.goodsCode = data.code
      this.goods.goodsName = data.name
      this.goods.isHiddle = data.isHiddle
      this.goods.isEnjoyPolic = data.isEnjoyPolic
      this.goods.policyType = data.policyType
      this.goods.goodsCodeId = data.id
    },
    search() {
      this.getGoodsList()
    },
    pro() {
      if (this.pages.currentPage > 1) {
        this.pages.currentPage--
        this.getGoodsList()
      }
    },
    next() {
      if (this.pages.currentPage < this.pages.totalPage) {
        this.pages.currentPage++
        this.getGoodsList()
      }
    },
    changeShowCount(val) {
      this.pages.showCount = val
      this.pages.currentPage = 1
      this.getGoodsList()
    },
    initGoods() {
      for (const key in this.goods) {
        this.goods[key] = ''
      }
    },
    editGoods(type) {
      if (type === 'edit') {
        this.modalType = '编辑'
        if (!this.selectedRowKeys.length) {
          this.$notification['warning']({
            message: '请选择一行进行修改',
          })
          return false
        }
        this.getGoods()
      } else if (type === 'add') {
        this.modalType = '添加'
        this.initGoods()
        this.goods.enterpriseId = this.LOGIN_INFO.eid
        this.goods.stuId = this.LOGIN_INFO.stuId
        this.goods.domain = this.LOGIN_INFO.domain
        this.goods.haveTax = 'N'
        this.goods.isEnjoyPolic = 'N'
        this.goods.isHiddle = 'N'
      }
      this.isEdit = true
    },
    getGoods() {
      this.goods = JSON.parse(JSON.stringify(this.selectedRowKeys[0]))
    },
    deletGoods() {
      if (!this.selectedRowKeys.length) {
        this.$notification['warning']({
          message: '请选择一行进行删除！',
        })
        return false
      }
      this.$confirm({
        title: '信息',
        content: '删除将不可恢复。确定删除?',
        onOk: async () => {
          const params = parseParam({
            id: this.selectedRowKeys[0].id,
          })
          const res = await this.$http.post(`${Urls.deleteGoods}&${params}`)
          if (res.statusCode === '200') {
            this.getGoodsList()
            this.$message.success('删除成功')
          }
        },
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    onSelect() {
      this.$emit('emitRowKey', this.selectedRowKeys)
    },
    onDbClick(selectedRowKeys) {
      this.$emit('emitRowKey', selectedRowKeys)
    },
    async submitFrom() {
      const type = this.goods.id ? 'edit' : 'add'
      // 后端保存的时候格式化前端goo对象
      if (!this.goods.name) {
        this.$notification['warning']({
          message: '商品名称不能为空!',
        })
        return
      }
      if (!this.goods.goodsCode) {
        this.$notification['warning']({
          message: '税收分类编码不能为空!',
        })
        return
      }
      if (!this.goods.taxRate && this.goods.taxRate !== 0) {
        this.$notification['warning']({
          message: '税率不能为空!',
        })
        return
      }
      if (!this.goods.haveTax) {
        this.$notification['warning']({
          message: '含税标志不能为空!',
        })
        return
      }
      const params = parseParam({
        data: JSON.stringify(this.goods),
      })
      this.submitLoad = true
      const res = await this.$http.post(`${Urls.saveGoods}&${params}`)
      if (res.statusCode === '200') {
        await this.getGoodsList()
        let content = ''
        if (type === 'edit') {
          content = '修改成功!'
        } else {
          content = '新增成功!'
        }
        this.$message.success(content)
      }
      this.cancelForm()
    },
    cancelForm() {
      this.submitLoad = false
      this.isEdit = false
      this.initGoods()
    },
  },
}
</script>

<style lang="less" scoped>
.main-content {
  display: flex;
  height: 100%;
  .left-cont {
    width: 15%;
    background-color: #e8f5ff;
    height: 100%;
    min-width: 200px;
  }
  .right-cont {
    flex: 1;
    padding: 10px 10px 20px 10px;
    overflow: auto;
    .export-import {
      text-align: right;
      button {
        margin-left: 10px;
      }
    }
    .option-btn {
      display: flex;
      justify-content: space-between;
      margin: 15px 0;
      .edit-group {
        button {
          margin-right: 10px;
        }
      }
      .search {
        display: flex;
        button {
          margin-left: 10px;
        }
      }
    }
  }
}
.left-cont {
  .left-edit {
    height: 50px;
    background-color: #d2ebff;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
</style>
<style lang="less">
// 修改标签栏
.ant-tabs-bar {
  margin: 0;
}
</style>
